import EcosiaUser from '@ecosia/ecosia-user';

import {
  MAIN as MAIN_COOKIE,
  SEARCHES_AFTER_INSTALL as ECSAI_COOKIE,
} from '~~/common/js/constants/cookies';
import { EXTENSION_ACTIVE } from '~~/common/js/constants/storage-keys';
import { getCookieOptions } from '~~/common/js/universal/utils';
import { sendEvent } from '~~/common/js/client/analytics';

const isExtensionMessage = (event) => window.location.href.indexOf(event.origin) === 0;

export default (context) => {
  if (process.server) {
    return;
  }

  // This overwrites any existing ECFG cookie in 'ecosiaUser' magic
  const cookieString = context.app.$cookies.get(MAIN_COOKIE);
  const ecsaiCookieSet = !!context.app.$cookies.get(ECSAI_COOKIE);

  // Remove extension flag
  // it will be reset when the version event is detected
  sessionStorage.removeItem(EXTENSION_ACTIVE);

  const user = new EcosiaUser({
    cookieString,
    acceptLanguage: navigator.language,
    userAgent: navigator.userAgent,
  });
  user.setFlowStage();

  window.addEventListener('message', (event) => {
    if (isExtensionMessage(event)) {
      let data;
      try {
        data = JSON.parse(event.data);
      } catch (err) {
        return;
      }
      if (!data || typeof data !== 'object') {
        return;
      }

      const { addon, version } = data;
      if (data.event === 'firstSearch') {
        user.set('firstRun', 1);
        user.set('addOn', 1);
        sendEvent('addon_install', { addon, version });
        sendEvent('first_search_after_install', {
          addon,
          version,
          position: 'legacy_addon',
        });
      }

      if (data.event === 'version') {
        sendEvent('addon_present', { addon, version });
        sessionStorage.setItem(EXTENSION_ACTIVE, 'true');

        // The firefox web-extension does not set the ECSAI install cookie
        // because it is not redirecting the user to the firstrun page after installing.
        // Every exttension sends the 'version' event which let's us verify that the user
        // has the extension installed.
        if (!ecsaiCookieSet) {
          // Re-add this cookie in case it has been deleted
          // Set value to 2 to prevent firing event twice
          context.app.$cookies.set(ECSAI_COOKIE, 2, getCookieOptions());
        }
      }
    }
  });
};
